var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBehaviouralsafety(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_1315)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.5 28C37.5 26.9888 36.8909 26.0773 35.9567 25.6903C35.0225 25.3033 33.9472 25.5172 33.2322 26.2322L18.2322 41.2322C17.2559 42.2085 17.2559 43.7915 18.2322 44.7678L33.2322 59.7678C33.9472 60.4828 35.0225 60.6967 35.9567 60.3097C36.8909 59.9227 37.5 59.0112 37.5 58V51.5H70C71.3807 51.5 72.5 50.3807 72.5 49V43V37C72.5 35.6193 71.3807 34.5 70 34.5H37.5V28ZM75.5 34.5C74.1193 34.5 73 35.6193 73 37V43V49C73 50.3807 74.1193 51.5 75.5 51.5H81C82.3807 51.5 83.5 50.3807 83.5 49V43V37C83.5 35.6193 82.3807 34.5 81 34.5H75.5ZM86.5 34.5C85.1193 34.5 84 35.6193 84 37V43V49C84 50.3807 85.1193 51.5 86.5 51.5H92C93.3807 51.5 94.5 50.3807 94.5 49V43V37C94.5 35.6193 93.3807 34.5 92 34.5H86.5ZM74.5 91.5C74.5 92.5112 75.1091 93.4227 76.0433 93.8097C76.9775 94.1966 78.0528 93.9828 78.7678 93.2678L93.7678 78.2678C94.7441 77.2915 94.7441 75.7085 93.7678 74.7322L78.7678 59.7322C78.0528 59.0172 76.9775 58.8033 76.0433 59.1903C75.1091 59.5773 74.5 60.4888 74.5 61.5V68H42C40.6193 68 39.5 69.1193 39.5 70.5V76.5V82.5C39.5 83.8807 40.6193 85 42 85H74.5V91.5ZM36.5 85C37.8807 85 39 83.8807 39 82.5V76.5V70.5C39 69.1193 37.8807 68 36.5 68H31C29.6193 68 28.5 69.1193 28.5 70.5V76.5V82.5C28.5 83.8807 29.6193 85 31 85H36.5ZM25.5 85C26.8807 85 28 83.8807 28 82.5V76.5V70.5C28 69.1193 26.8807 68 25.5 68H20C18.6193 68 17.5 69.1193 17.5 70.5V76.5V82.5C17.5 83.8807 18.6193 85 20 85H25.5Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinejoin: "round",
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 28V37H70V43V49H35V58L20 43L35 28Z",
    fill: "#00A0F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5 37V43V49H81V43V37H75.5Z",
    fill: "#00A0F3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5 37V43V49H92V43V37H86.5Z",
    fill: "#00A0F3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77 91.5V82.5H42V76.5V70.5H77V61.5L92 76.5L77 91.5Z",
    fill: "#00A0F3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 82.5V76.5V70.5H31V76.5V82.5H36.5Z",
    fill: "#00A0F3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 82.5V76.5V70.5H20V76.5V82.5H25.5Z",
    fill: "#00A0F3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35 28V37H70V43V49H35V58L20 43L35 28Z",
    stroke: "#052D41",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5 37V43V49H81V43V37H75.5Z",
    stroke: "#052D41",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5 37V43V49H92V43V37H86.5Z",
    stroke: "#052D41",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M77 91.5V82.5H42V76.5V70.5H77V61.5L92 76.5L77 91.5Z",
    stroke: "#052D41",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 82.5V76.5V70.5H31V76.5V82.5H36.5Z",
    stroke: "#052D41",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 82.5V76.5V70.5H20V76.5V82.5H25.5Z",
    stroke: "#052D41",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_1315",
    x: 13,
    y: 21.9999,
    width: 88,
    height: 79.5002,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0196078 0 0 0 0 0.176471 0 0 0 0 0.254902 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_1315"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_1315",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBehaviouralsafety);
export default __webpack_public_path__ + "static/media/behaviouralsafety.414cce66a60cbbd9fec217d38cb81210.svg";
export { ForwardRef as ReactComponent };